module.exports = __webpack_public_path__ + "img/animals_02_H.a9800276.jpg";